import {createContext} from 'react';
import {filterData} from '../components/DropdownFilter';

export interface userType {
    id: number,
    firstName: string,
    lastName: string,
    email: string
}

export interface favouriteType {
    id: number,
    userId: number,
    companyGroupId: number,
}

export interface filterDataType {
    coverage: filterData[],
    facilityType: filterData[],
    carrier: filterData[],
    wholesaler: filterData[],
    states: filterData[],
    contacts: any[],
    users: userType[],
    favourites: favouriteType[] | null,
    search: string,
    order: number,
    submissionReq: filterData[],
    categories: filterData[],
    companyCategories: []
}

export interface filterContextType {
    filterContent: filterDataType,
    filterData: filterDataType,
    setFilterContent: (filter: filterDataType)=> void,
    setFilterData: (filter: filterDataType, filterKey: string)=> void,
}

export const initialValues: filterDataType = {
    coverage: [],
    facilityType: [],
    carrier: [],
    wholesaler: [],
    states: [],
    contacts: [],
    users: [],
    favourites: [],
    search: '',
    order: 0,
    submissionReq: [],
    categories: [],
    companyCategories: []
}

const FilterContext = createContext<filterContextType>({
        filterContent: initialValues,
        filterData: initialValues,
        setFilterContent: () => undefined,
        setFilterData: () => undefined,

});

export {FilterContext};

